import { StatusBadge } from "./StatusBadge"

export const ProgressionTimeline = ({ history }) => {
  if (!history || history.length === 0) {
    return (
      <div className="text-center text-gray-500 py-8">
        No progression history available
      </div>
    )
  }

  return (
    <div className="space-y-4">
      {history.map((entry, index) => (
        <div key={entry.id} className="flex gap-4">
          {/* Timeline indicator */}
          <div className="flex flex-col items-center">
            <div className={`w-3 h-3 rounded-full ${
              entry.change_type === 'manual' ? 'bg-blue-500' : 'bg-gray-400'
            }`} />
            {index < history.length - 1 && (
              <div className="w-0.5 h-full bg-gray-300 flex-1 mt-1" />
            )}
          </div>

          {/* Content */}
          <div className="flex-1 pb-8">
            <div className="grid grid-cols-3 items-center gap-2 mb-1">
              {entry.from_status && <StatusBadge status={entry.from_status} />}
              {entry.from_status && <i className="fa-solid fa-arrow-right text-gray-400 text-center"></i>}
              <StatusBadge status={entry.to_status} />
            </div>

            <div className="text-sm text-gray-600 mt-2">
              {entry.changed_by ? (
                <span>
                  Changed by <span className="font-medium">{entry.changed_by.name}</span>
                </span>
              ) : (
                <span>System change</span>
              )}
              {' · '}
              <span className="capitalize">{entry.change_type?.replaceAll('_', ' ')}</span>
            </div>

            <div className="text-xs text-gray-400 mt-1">
              {new Date(entry.created_at).toLocaleString()}
            </div>

            {entry.notes && (
              <div className="text-sm text-gray-600 mt-2 italic">
                {entry.notes}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}
